import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newData: {
    countryOfInterest: "",
    visaCategory: "",
    id: "",
    status:"",
    isSubmit:false,
applicationID:""
  },
};

const createApplicationSlice = createSlice({
  name: "createApplication",
  initialState,
  reducers: {
    setApplicationData: (state, action) => {
      state.newData = { ...state.newData, ...action.payload };
    },
    clearApplicationData: (state) => {
      state.newData = initialState.newData;
    },
  },
});

export const { setApplicationData, clearApplicationData } = createApplicationSlice.actions;
export default createApplicationSlice.reducer;